// import { VALIDATION_REGEX } from '@parent-app/config';

import { VALIDATION_REGEX } from "src/shared/config/src";

export const isValidEmail = (email: string) => {
        if (!email)
                return false;

        if (email.length > 254)
                return false;

        const valid = VALIDATION_REGEX.EMAIL.test(email);
        if (!valid)
                return false;

        const parts = email.split("@");
        if (parts[0].length > 64)
                return false;

        const domainParts = parts[1].split(".");
        if (domainParts.some(function (part) { return part.length > 63; }))
                return false;

        return true;
}

type Rule = 
  | { regex: RegExp; description: string; test?: null } 
  | { test: (password: string) => boolean; description: string; regex?: null };

export const validatePassword = (password: string) => {
    const errors: Record<string, Rule> = {
        digit: { regex: /[0-9]/, description: 'At least one digit' },
        special: { regex: /[^A-Za-z0-9]/, description: 'At least one special symbol' },
        uppercase: { regex: /[A-Z]/, description: 'At least one uppercase letter' },
        lowercase: { regex: /[a-z]/, description: 'At least one lowercase letter' },
        length: { test: (e) => e.length > 8, description: 'Should be more than 8 characters' },
    };

    return Object.entries(errors).flatMap(([name, rule]) => {
        const { test, regex, description } = rule;
        const isValid = test ? test(password) : regex?.test(password);
        return isValid ? [] : { description, name };
    });
};
